import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';


const __default__ = {
  name: "CheckBox",
  inheritAttrs: false,
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  label: {
      type: String,
      require: true,
      default: () => null,
    },
},
  emits: {
  status: (value: boolean) => true,
},
  setup(__props, { expose: __expose, emit: $emits }) {
  __expose();

const $props = __props;





const keep_me_logged_in = ref<boolean>(true);
const randomId = ref<string>('');

watch(keep_me_logged_in, (newVal) => {
  $emits("status", newVal);
})

const __returned__ = { $props, $emits, keep_me_logged_in, randomId, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})